// sticky menu
(function() {
    var mainNav = document.getElementById('main-nav');
    var mainNavSticky = document.getElementById('main-nav-sticky-version');
    var topMenu = document.getElementById('top-menu');


    var mainNavPlaceholder = null;
    var topMenuPlaceholder = null;

    function ensurePlaceholder(afterElement, existingPlaceholderId) {
        if (!afterElement) return null;
        var ph = document.getElementById(existingPlaceholderId);
        if (!ph) {
            ph = document.createElement('div');
            ph.id = existingPlaceholderId;
            ph.style.width = '100%';
            ph.style.height = '0px';
            ph.style.pointerEvents = 'none';
            ph.setAttribute('aria-hidden', 'true');
        }

        if (afterElement.parentNode) {
            var desiredNext = afterElement.nextSibling;
            if (ph.previousSibling !== afterElement) {
                afterElement.parentNode.insertBefore(ph, desiredNext);
            }
        }
        return ph;
    }

    function getPosition(el) {
        if (!el) return '';
        return window.getComputedStyle(el).position;
    }

    function setOpacity(el, value) {
        if (!el) return;
        el.style.opacity = String(value);
    }


    function updateSticky() {
        var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var isMobile = window.innerWidth < 1024;

        if (isMobile && mainNavSticky) {
            mainNavSticky.classList.remove('sticky');
            mainNavSticky.classList.add('hidden');
            if (mainNav) setOpacity(mainNav, 1);
            if (mainNavPlaceholder) mainNavPlaceholder.style.height = '0px';
        } else {
            if (mainNav && mainNavSticky) {
                var trigger = mainNav.offsetTop || 0;
                var shouldStick = pageY > trigger;

                var pos = getPosition(mainNav);
                var outOfFlow = (pos === 'absolute' || pos === 'fixed');

                if (shouldStick) {
                    mainNavSticky.classList.add('sticky');
                    mainNavSticky.classList.remove('hidden');
                    setOpacity(mainNav, 0);

                    if (outOfFlow) {
                        mainNavPlaceholder = ensurePlaceholder(mainNav, 'main-nav-placeholder');
                        if (mainNavPlaceholder) {
                            var h = mainNavSticky.offsetHeight || 0;
                            mainNavPlaceholder.style.height = h + 'px';
                        }
                    } else if (mainNavPlaceholder) {
                        mainNavPlaceholder.style.height = '0px';
                    }
                } else {
                    mainNavSticky.classList.remove('sticky');
                    mainNavSticky.classList.add('hidden');
                    setOpacity(mainNav, 1);
                    if (mainNavPlaceholder) mainNavPlaceholder.style.height = '0px';
                }
            }
        }

        if (topMenu) {
            var triggerTop = topMenu.offsetTop || 0;
            var shouldStickTop = isMobile && pageY > triggerTop;
            if (shouldStickTop) {
                topMenu.classList.add('sticky');
                var isHeader1 = !!document.querySelector('.header-1-bg');
                var anchor = (isHeader1 && mainNav) ? mainNav : topMenu;
                topMenuPlaceholder = ensurePlaceholder(anchor, 'top-menu-placeholder');
                if (topMenuPlaceholder) {
                    var th = topMenu.offsetHeight || 0;
                    topMenuPlaceholder.style.height = th + 'px';
                }
            } else {
                topMenu.classList.remove('sticky');
                if (topMenuPlaceholder) topMenuPlaceholder.style.height = '0px';
            }
        }
    }

    function onResize() {
        updateSticky();
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', onResize);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateSticky);
    } else {
        updateSticky();
    }
})();
